import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=83fdd736&scoped=true&"
import script from "./Title.vue?vue&type=script&lang=js&"
export * from "./Title.vue?vue&type=script&lang=js&"
import style0 from "./Title.vue?vue&type=style&index=0&id=83fdd736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fdd736",
  null
  
)

export default component.exports